import React, { useState, useEffect } from "react";

const IdleTimer = ({ timeout, onIdle, loginHandler }) => {
  const [isIdle, setIsIdle] = useState(false);

  useEffect(() => {
    let idleTimeout;

    const handleUserActivity = () => {
      clearTimeout(idleTimeout);
      setIsIdle(false);

      idleTimeout = setTimeout(() => {
        setIsIdle(true);
        onIdle();
      }, timeout);
    };

    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);
    window.addEventListener("click", handleUserActivity);

    return () => {
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
      window.addEventListener("click", handleUserActivity);
      clearTimeout(idleTimeout);
    };
  }, [timeout, onIdle, loginHandler]);
};

export default IdleTimer;
